import { createReducer, on } from '@ngrx/store';
import * as UserRolesActions from './user-roles.actions';
import { UserRolesState } from './user-roles.models';

export const initialState: UserRolesState = {
  roles: {},
  loading: undefined,
  error: null,
  currentUserGuid: null,
  currentCertifyRole: undefined,
  lastRoles: undefined,
};

export const userRolesReducer = createReducer(
  initialState,
  on(UserRolesActions.loadUserRoles, (state) => ({
    ...state,
    loading: undefined,
    error: null,
  })),
  on(UserRolesActions.loadUserRolesSuccess, (state, { userGuid, roles }) => ({
    ...state,
    loading: false,
    error: null,
    roles: { [userGuid]: roles },
    currentUserGuid: userGuid,
    lastRoles: roles,
  })),
  on(UserRolesActions.loadingUserRoles, (state, { loading }) => ({
    ...state,
    loading,
  })),
  on(UserRolesActions.loadUserRolesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(UserRolesActions.setCurrentCertifyRole, (state, { role }) => ({
    ...state,
    currentCertifyRole: role,
  })),
  on(UserRolesActions.resetUserRoles, () => initialState),
);
